import React, { useState, useEffect } from "react";
import axios from "axios";

const CityDropdown = ({ formData, setFormData, errors }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredCities, setFilteredCities] = useState([]);
  const [cities, setCities] = useState({});
  const [isDropdownVisible, setIsDropdownVisible] = useState(false);
  const [isValidCity, setIsValidCity] = useState(true);

  useEffect(() => {
    // Fetch the cities from your JSON or API
    const fetchCities = async () => {
      try {
        const response = await axios.get("/cities.json"); // Update with the correct path or API
        setCities(response.data);
      } catch (error) {
        console.error("Error fetching cities:", error);
      }
    };
    fetchCities();
  }, []);

  useEffect(() => {
    // Filter cities based on the search term
    const filtered = Object.keys(cities)
      .filter((city) => city.toLowerCase().includes(searchTerm.toLowerCase()))
      .sort();
    setFilteredCities(filtered);
    validateCity(searchTerm, filtered);
  }, [searchTerm, cities]);

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
    setIsDropdownVisible(true); // Show dropdown on typing
  };

  const handleCitySelect = (city) => {
    setFormData((prev) => ({ ...prev, city }));
    setSearchTerm(city);
    setIsDropdownVisible(false); // Hide dropdown on selection
    setIsValidCity(true);
  };

  const validateCity = (term, filtered) => {
    if (!term) {
      setIsValidCity(true);
      return;
    }
    setIsValidCity(filtered.includes(term));
  };

  const handleBlur = () => {
    // Hide dropdown on losing focus
    setTimeout(() => setIsDropdownVisible(false), 200); // Delay to allow click on a dropdown item
  };

  const handleFocus = () => {
    if (filteredCities.length > 0) {
      setIsDropdownVisible(true); // Show dropdown when input is focused and has results
    }
  };

  return (
    <div className="col-md-6 mt-3">
      <div className="form-group">
        <label className="input_title" htmlFor="city">City <sup>*</sup></label>
        <input
          id="citySearch"
          className={`form-control ${errors.city || !isValidCity ? "is-invalid" : ""}`}
          type="text"
          placeholder="Search for a city"
          value={searchTerm}
          onChange={handleSearch}
          onBlur={handleBlur}
          onFocus={handleFocus}
        />
        {(!isValidCity || errors.city) && (
          <span className="text-danger">
            {errors.city || "Invalid city selected"}
          </span>
        )}
        {isDropdownVisible && filteredCities.length > 0 && (
          <ul className="custom-dropdown show">
            {filteredCities.map((city, index) => (
              <li
                key={index}
                className="custom-dropdown-item"
                onClick={() => handleCitySelect(city)}
              >
                {city}, {cities[city]} {/* Show city and county */}
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
};

export default CityDropdown;
